<template>
    <div id="upgrade-plan-container" v-if="account.plan_id < 2 || account.plan_id > 5">
        <div style="width: 100%; gap: 15px;"
             class="d-flex align-center justify-space-between">
            <span style="color: #fff; font-size: 12px; font-weight: bold">Plan: fylm.ai Free</span>
            <v-btn @click="upgradePlan"
                   class="rounded-xl my-auto upgrade-plan-btn"
                   small
                   outlined
                   color="white"
            >
                Upgrade plan
            </v-btn>
        </div>
    </div>

    <div v-else id="project-members-container">
        <ProjectMembersEditButton v-if="!isGuest" />
        <ProjectMembersAvatarList v-if="!isGuest" />
    </div>
</template>
<script>
import ProjectMembersAvatarList from "@/components/app/projects/ProjectMembersAvatarList.vue";
import ProjectMembersEditButton from "@/components/app/buttons/ShowProjectMembersModalButton.vue";
import { mapGetters, mapState } from "vuex";

export default {
    components: {ProjectMembersEditButton, ProjectMembersAvatarList},

    computed: {
        ...mapState("User", ["account"]),
        ...mapGetters('User', ['isGuest']),
    },

    methods: {
        upgradePlan() {
            this.$router.push({name: "account.billing.changePlan"});
        },
    }
}
</script>

<style land="scss" scoped>
#project-members-container,
#upgrade-plan-container {
    padding: 0 12px;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 10;
}
</style>